import axios from 'axios'
import { Message } from 'element-ui'
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/utils/loading'
import store from '@/store'
import { baseUrl } from '@/config/index'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'
import { isAdminRoute } from '@/constants/admin'

// 创建一个 axios 实例
const base = process.env.NODE_ENV === 'development' ? '/api' : baseUrl
console.log(base, 'base-------')
const service = axios.create({
    baseURL: base,
    timeout: 100000
})

function isOnAdminPage() {
    const current = router.currentRoute
    return current && isAdminRoute(current.path)
}

function handleUnauthorized(message) {
    removeToken()
    store.dispatch('user/resetToken')
    Message({
        message: message || '未登录或登录已过期，请重新登录',
        type: 'error',
        duration: 5 * 1000
    })
    // 官网前台：401 不跳转，留在当前页
    if (!isOnAdminPage()) return
    // 管理后台：跳转登录页
    const current = router.currentRoute
    const query = current && current.fullPath && current.path !== '/login'
        ? { redirect: current.fullPath }
        : {}
    router.replace({ path: '/login', query }).catch(() => {})
}

function getResponseData(data) {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data)
        } catch (e) {
            return null
        }
    }
    return data
}

function getBizCode(data) {
    const payload = getResponseData(data)
    if (!payload || payload.code == null) return null
    return Number(payload.code)
}

function getResponseMessage(data) {
    const payload = getResponseData(data)
    return payload && payload.message
}

function redirectToLoginIfAdmin(message) {
    if (!isOnAdminPage()) return
    removeToken()
    store.dispatch('user/resetToken')
    Message({
        message: message || '登录超时，请重新登录',
        type: 'error',
        duration: 5 * 1000
    })
    router.replace({ path: '/login' }).catch(() => {})
}

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        config.headers['token'] = token
        const onAdmin = isOnAdminPage()
        const enableLoading = config.isLoading !== false && config.headers.isLoading !== false && !onAdmin
        if (enableLoading) {
            showFullScreenLoading()
            config.__loading = true
        }
        if (store.getters.token) {
            config.headers['token'] = getToken()
        }
        return config
    },
    error => {
        if (error.config && error.config.__loading) {
            tryHideFullScreenLoading()
        }
        console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.config && response.config.__loading) {
            tryHideFullScreenLoading()
        }
        const res = response.data
        if (response.config && response.config.responseType === 'blob') {
            return response
        }
        if (getBizCode(res) === 401) {
            handleUnauthorized(res.message)
            return Promise.reject(new Error(res.message || '未登录或登录已过期'))
        }
        if (res.code !== 200) {
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res
    },
    error => {
        console.log(error, 'error-request')
        if (error.config && error.config.__loading) {
            tryHideFullScreenLoading()
        }
        const response = error.response
        const data = response && response.data
        const bizCode = getBizCode(data)
        const httpStatus = response && Number(response.status)

        if (bizCode === 401 || httpStatus === 401) {
            handleUnauthorized(getResponseMessage(data))
            return Promise.reject(error)
        }
        if (httpStatus === 302) {
            redirectToLoginIfAdmin('登录超时，请重新登录')
        } else if (error.message.includes('Network Error')) {
            redirectToLoginIfAdmin('登录超时，请重新登录')
        } else {
            Message({
                message: '内部错误，请联系管理员',
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
